import { createContext, type Dispatch } from 'react';

type HttpStatusCode = number;
export type ErrorCode = HttpStatusCode | 'unknown';

interface ErrorContextValue {
  globalError: ErrorCode | null;
  setGlobalError: Dispatch<ErrorCode | null>;
}

const ErrorContext = createContext<ErrorContextValue>({
  globalError: null,
  setGlobalError: () => {},
});

export default ErrorContext;
